import {Injectable} from '@angular/core'
import {Subject} from 'rxjs'
import {ToastrService} from 'ngx-toastr'

export enum NotificationType {
  Message,
  Warning,
  Error,
}

export interface Notification {
  msg: string
  title?: string
  disableTimeOut?: boolean
  tapToDismiss?: any
  type: NotificationType
}

@Injectable()
export class NotificationService {
  notifications$ = new Subject<Notification>()
  closeAllNotifications$ = new Subject<void>()

  constructor(private toastr: ToastrService) {}

  notify(notification: Notification): void {
    this.notifications$.next(notification)

    const title = notification.title || undefined
    switch (notification.type) {
      case NotificationType.Error:
        this.toastr.error(notification.msg, title, {
          ...notification,
          onActivateTick: true,
        })
        break
      case NotificationType.Warning:
        this.toastr.warning(notification.msg, title, {
          ...notification,
          onActivateTick: true,
        })
        break
      case NotificationType.Message:
        this.toastr.info(notification.msg, title, {
          ...notification,
          onActivateTick: true,
        })
        break
    }
  }

  info(msg: string, title?: string): void {
    this.notify({msg: msg, title: title, type: NotificationType.Message})
  }

  error(msg: string, title?: string): void {
    this.notify({msg: msg, title: title, type: NotificationType.Error})
  }

  warn(msg: string, title?: string): void {
    this.notify({msg: msg, title: title, type: NotificationType.Warning})
  }

  closeAll() {
    this.closeAllNotifications$.next()
    this.toastr.clear()
  }
}
